var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-edited-indicator"},[(_setup.isTriggered)?_c(_setup.CheckIcon,{staticClass:"c-check-icon"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }